// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"584":"AdminDashboard","752":"consumos","806":"user","809":"users"}[chunkId] || chunkId) + "." + {"275":"1b411b89","354":"97a7f1b1","584":"ee7797cf","668":"79df1f99","752":"10e2e1ea","806":"ae9408a6","809":"ab603ab7","838":"85cc620f"}[chunkId] + ".js";
};